/**
 * The Android app's launcher icon, long-pressed: a "new task in <repo>" per repo
 * heading on the board on screen, in the reader's own heading order. The page
 * decides the list, since only it knows the board; the app just publishes what
 * it is handed (RepoShortcuts in android/…/RepoShortcuts.kt), and a tap comes
 * back through `window.__todosNative.newTask` (lib/taskRoute.ts).
 *
 * It follows the board last on screen rather than listing every team's repos:
 * the launcher shows only a handful, and those should be where the reader works.
 */
import { onBeforeUnmount, watch } from "vue";
import { PERSONAL, useBoard } from "../stores/board.js";

export function useAppShortcuts(): void {
  const bridge = window.todosAndroid;
  if (!bridge?.setRepoShortcuts) return;
  const board = useBoard();

  watch(
    () => {
      if (!board.loaded) return null;
      const team = board.teamId ?? PERSONAL;
      const repos = board.visibleRows.flatMap((r) => (r.kind === "group" && r.repo ? [r.repo] : []));
      return JSON.stringify(repos.map((repo) => ({ team, repo })));
    },
    (json) => {
      if (json !== null) bridge.setRepoShortcuts?.(json);
    },
    { immediate: true },
  );

  // Signed out: the next person must not find this one's repos on the icon.
  onBeforeUnmount(() => bridge.setRepoShortcuts?.("[]"));
}
